/**
 * Classes visuais padrão para formulários em fundo claro (#f0f4f8, cards brancos, etc.).
 * Manter alinhado a {@link Input} variant `light` e {@link CustomSelect} variant `default`.
 */

/** Rótulo acima do campo (leitura; caixa do controle segue `FORM_FIELD_CONTROL_APP`). */
export const FORM_FIELD_LABEL_APP =
  'block text-sm font-medium text-navy-dark mb-1';

/**
 * Input / select “caixa” no app — altura mínima alinhada ao trigger do CustomSelect.
 * Textareas podem acrescentar `resize-y min-h-[...]` por cima do min-height.
 */
export const FORM_FIELD_CONTROL_APP =
  'w-full max-w-full min-w-0 rounded-lg border border-border-light bg-[#fafbfc] px-3 py-2.5 text-sm text-text-body placeholder:text-text-muted min-h-[40px] box-border focus:outline-none focus:border-cyan focus:ring-1 focus:ring-cyan transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed';

/**
 * Altura única alinhada a inputs/selects (40px / `h-10`) — botões de atalho na mesma linha.
 */
export const FORM_FIELD_ROW_HEIGHT_CLASS = 'min-h-[40px] h-10';

/**
 * Valor só leitura (ex.: data calculada) — mesma altura que campos editáveis.
 */
export const FORM_FIELD_READOUT_APP =
  'min-h-[40px] h-10 w-full min-w-0 sm:w-44 sm:min-w-44 flex items-center justify-center sm:justify-start rounded-lg border border-border-light bg-[#e2e6eb] px-3 text-sm font-semibold text-navy-dark tabular-nums overflow-hidden';
